export default {
    nav: '回饋',
    dialog: {
        titleList: '我的回饋',
        titleNew: '新建回饋',
        titleDetail: '回饋詳情',
    },
    list: {
        new: '新建回饋',
        loading: '載入中...',
        empty: '還沒有回饋記錄，你的每一條意見都會讓產品變得更好',
        delete: '刪除',
    },
    status: {
        pending: '待處理',
        processing: '處理中',
        resolved: '已解決',
        closed: '已關閉',
    },
    category: {
        bug: '缺陷',
        suggestion: '建議',
        feature_request: '功能請求',
        other: '其它',
    },
    form: {
        intro: '你的回饋對我們非常重要，每一條都會被認真閱讀',
        titleLabel: '標題',
        titlePlaceholder: '請簡要描述問題或建議',
        categoryLabel: '類型',
        contentLabel: '描述',
        contentPlaceholder: '請詳細描述您遇到的問題或建議，越詳細越好...',
        cancel: '取消',
        submit: '提交回饋',
        submitting: '提交中...',
        bold: '粗體',
        italic: '斜體',
        strikethrough: '刪除線',
        bulletList: '無序列表',
        orderedList: '有序列表',
        blockquote: '引用',
    },
    success: {
        title: '感謝你的回饋！',
        message: '我們已經收到你的回饋，團隊會認真閱讀並盡快跟進。你的每一條意見都在幫助我們做得更好。',
        viewList: '查看我的回饋',
    },
    detail: {
        back: '返回列表',
        replyPlaceholder: '追加回覆...',
        send: '發送',
        sending: '發送中',
        uploadImage: '上傳圖片',
    },
}
